import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { LMCommonUtilService } from '@utils/lm-common-util.service';

@Component({
  selector: 'lm-simple-progress',
  templateUrl: './lm-simple-progress.component.html',
  styleUrls: ['./lm-simple-progress.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class LMSimpleProgressComponent implements OnInit {

  @Input() lmProgressFieldData: LMProgressFieldData;

  public width: number;
  public displayValue: string;
  public title: string;
  public colorClass: string;
  public inverseClass = '';

  constructor(private lmCommonUtil: LMCommonUtilService) { }

  ngOnInit() {
    const color = this.lmCommonUtil.getRangeColor(this.lmProgressFieldData.ranges, Number(this.lmProgressFieldData.field.value), this.lmProgressFieldData.dataView)
    const rangeText =  this.lmProgressFieldData.meterRangeValue ?  this.lmProgressFieldData.meterRangeValue : '100';

    this.width = this.getWidth();
    this.displayValue = this.lmProgressFieldData.displayPercent ? this.lmProgressFieldData.value.toString() + '%' : this.lmProgressFieldData.value.toString();
    this.title = this.displayValue + ' of ' + rangeText;
    this.colorClass = 'lm-completed lm-' + color;

    if (this.width > 55) {
      this.inverseClass = 'lm-inverse';
    }
  }

  /**
   * Converts value to a percentage for bar width
   * @returns
   */
  private getWidth(): number {
    const rangeValue = this.lmProgressFieldData.meterRangeValue ? this.lmProgressFieldData.meterRangeValue : 100;
    const value = Number(this.lmProgressFieldData.field.value);

    if (this.lmProgressFieldData.field.value > 1) {
      return (value / rangeValue) * 100;
    } else if (this.lmProgressFieldData.field.value <= 1) {
      return value * 100;
    } else {
      return value;
    }
  }
}
